import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const useUserRole = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for auth to finish loading
    if (!authLoading) {
      setLoading(false);
    }
  }, [authLoading]);

  const userRole = user?.role || null;

  console.log('🔍 useUserRole: Using AuthContext role:', userRole);
  console.log('🔍 useUserRole: User object:', {
    uid: user?.uid,
    email: user?.email,
    role: user?.role,
    status: user?.status
  });

  const isAdmin = userRole === 'admin';
  const isUser = userRole === 'user';
  const isSupplier = userRole === 'supplier';

  return {
    role: userRole,        // For compatibility with MaterialRequestsPage
    userRole,
    isAdmin,
    isUser,
    isSupplier,
    loading: loading || authLoading
  };
};